<template>
  <div class="goodsManageSet">
    <div class="banner">
      <img src="../../../assets/images/banner1.png" alt="" />
    </div>
    <div class="breadcrumb flex-rowc">
      <div class="breadcrumb_icon">
        <i class="iconfont icon-shangpinsku"></i>
      </div>
      <div class="breadcrumb_item">SKU管理</div>
      <div class="breadcrumb_item_arrow"></div>
      <div class="breadcrumb_item">商品管理</div>
    </div>

    <div class="main_content">
      <div class="tit">商品图片设置</div>
      <div class="block">
        <h1><span class="mark">*</span>商品封面（缩略图）</h1>
        <p class="red">JPG或者PNG格式，尺寸比例宽度500像素，高度不限制</p>
        <div class="img_box">
          <van-uploader
            v-model="fileList"
            @click-upload="clickUpload(1)"
            @delete="deleteImg(1)"
            :before-read="beforeRead"
            :after-read="afterRead"
            :max-count="1"
          />
        </div>
      </div>

      <div class="block">
        <h1><span class="mark">*</span>商品banner1</h1>
        <p class="red">JPG或者PNG格式，尺寸比例宽度750像素，高度不限制</p>
        <div class="img_box">
          <van-uploader
            v-model="fileList1"
            @click-upload="clickUpload(2)"
            @delete="deleteImg(2)"
            :before-read="beforeRead"
            :after-read="afterRead"
            :max-count="1"
          />
        </div>
      </div>

      <div class="block">
        <h1>商品banner2</h1>
        <p class="red">JPG或者PNG格式，尺寸比例宽度750像素，高度不限制</p>
        <div class="img_box">
          <van-uploader
            v-model="fileList2"
            @click-upload="clickUpload(3)"
            @delete="deleteImg(3)"
            :before-read="beforeRead"
            :after-read="afterRead"
            :max-count="1"
          />
        </div>
      </div>

      <div class="block">
        <h1>商品banner3</h1>
        <p class="red">JPG或者PNG格式，尺寸比例宽度750像素，高度不限制</p>
        <div class="img_box">
          <van-uploader
            v-model="fileList3"
            @click-upload="clickUpload(4)"
            @delete="deleteImg(4)"
            :before-read="beforeRead"
            :after-read="afterRead"
            :max-count="1"
          />
        </div>
      </div>

      <div class="block">
        <h1>商品banner4</h1>
        <p class="red">JPG或者PNG格式，尺寸比例宽度750像素，高度不限制</p>
        <div class="img_box">
          <van-uploader
            v-model="fileList4"
            @click-upload="clickUpload(5)"
            @delete="deleteImg(5)"
            :before-read="beforeRead"
            :after-read="afterRead"
            :max-count="1"
          />
        </div>
      </div>

      <div class="block">
        <h1>商品banner5</h1>
        <p class="red">JPG或者PNG格式，尺寸比例宽度750像素，高度不限制</p>
        <div class="img_box">
          <van-uploader
            v-model="fileList5"
            @click-upload="clickUpload(6)"
            @delete="deleteImg(6)"
            :before-read="beforeRead"
            :after-read="afterRead"
            :max-count="1"
          />
        </div>
      </div>

      <div class="block">
        <h1>商品banner6</h1>
        <p class="red">JPG或者PNG格式，尺寸比例宽度750像素，高度不限制</p>
        <div class="img_box">
          <van-uploader
            v-model="fileList6"
            @click-upload="clickUpload(7)"
            @delete="deleteImg(7)"
            :before-read="beforeRead"
            :after-read="afterRead"
            :max-count="1"
          />
        </div>
      </div>

      <div class="block">
        <h1>商品banner7</h1>
        <p class="red">JPG或者PNG格式，尺寸比例宽度750像素，高度不限制</p>
        <div class="img_box">
          <van-uploader
            v-model="fileList7"
            @click-upload="clickUpload(8)"
            @delete="deleteImg(8)"
            :before-read="beforeRead"
            :after-read="afterRead"
            :max-count="1"
          />
        </div>
      </div>

      <div class="block">
        <h1>商品banner8</h1>
        <p class="red">JPG或者PNG格式，尺寸比例宽度750像素，高度不限制</p>
        <div class="img_box">
          <van-uploader
            v-model="fileList8"
            @click-upload="clickUpload(9)"
            @delete="deleteImg(9)"
            :before-read="beforeRead"
            :after-read="afterRead"
            :max-count="1"
          />
        </div>
      </div>

       <div class="block">
        <h1>商品banner9</h1>
        <p class="red">JPG或者PNG格式，尺寸比例宽度750像素，高度不限制</p>
        <div class="img_box">
          <van-uploader
            v-model="fileList9"
            @click-upload="clickUpload(10)"
            @delete="deleteImg(10)"
            :before-read="beforeRead"
            :after-read="afterRead"
            :max-count="1"
          />
        </div>
      </div>

      <!-- <div class="block">
          <h1>商品banner6</h1>
          <p class="red">JPG或者PNG格式，尺寸比例宽度750像素，高度不限制</p>
          <div class="img_box">
            <van-uploader v-model="fileList6" @click-upload="clickUpload(7)" @delete="deleteImg(7)"
              :before-read="beforeRead" :after-read="afterRead" :max-count="1" />
          </div>
        </div> -->
    </div>

    <div class="primary-button" @click="handleSubmit">保存确认</div>

    <div class="primary-button return" @click="handleReturn">
      <i class="iconfont icon-yuyinjiantou"></i>返回
    </div>
  </div>
</template>

<script>
import {
  getCommidityDetail,
  editCommidity,
  uploadImage,
  encryptstringview,
} from "../../../api/api";
import { mapState } from "vuex";
export default {
  name: "cImages",
  data() {
    return {
      radio: "",
      searchText: "",
      isShowStyle: false,
      scrollTop: 0,

      isType: 1,

      fileList: [],
      fileList1: [],
      fileList2: [],
      fileList3: [],
      fileList4: [],
      fileList5: [],
      fileList6: [],
      fileList7: [],
      fileList8: [],
      fileList9: [],

      cmid: "",
      formData: {
        Method: "ams_shop_commodity_edit",
        id: "",
        img: "",
        banner: "",
        banner2: "",
        banner3: "",
        banner4: "",
        banner5: "",
        banner6: "",
        banner7: "",
        banner8: "",
        banner9: "",
      },
    };
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let { routerList } = this.$store.state;
    let { name } = this.$route;

    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, this.OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        this.cmid = id;
        this.getDetail();
      } else {
        this.$router.back();
      }
    },

    getDetail() {
      let { cmid } = this;
      const Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      getCommidityDetail({ id: cmid }).then((res) => {
        this.formData.id = res.id ? res.id : "";
        this.formData.img = res.img ? res.img : "";
        this.formData.banner = res.banner ? res.banner : "";
        this.formData.banner2 = res.banner2 ? res.banner2 : "";
        this.formData.banner3 = res.banner3 ? res.banner3 : "";
        this.formData.banner4 = res.banner4 ? res.banner4 : "";
        this.formData.banner5 = res.banner5 ? res.banner5 : "";
        this.formData.banner6 = res.banner6 ? res.banner6 : "";
        this.formData.banner7 = res.banner7 ? res.banner7 : "";
        this.formData.banner8 = res.banner8 ? res.banner8 : "";
        this.formData.banner9 = res.banner9 ? res.banner9 : "";

        if (res.img != "") {
          this.fileList.push({ url: res.img });
        }
        if (res.banner != "") {
          this.fileList1.push({ url: res.banner });
        }
        if (res.banner2 != "") {
          this.fileList2.push({ url: res.banner2 });
        }
        if (res.banner3 != "") {
          this.fileList3.push({ url: res.banner3 });
        }
        if (res.banner4 != "") {
          this.fileList4.push({ url: res.banner4 });
        }
        if (res.banner5 != "") {
          this.fileList5.push({ url: res.banner5 });
        }
         if (res.banner6 != "") {
          this.fileList6.push({ url: res.banner6 });
        }
         if (res.banner7 != "") {
          this.fileList7.push({ url: res.banner7 });
        }
         if (res.banner8 != "") {
          this.fileList8.push({ url: res.banner8 });
        }
         if (res.banner9 != "") {
          this.fileList9.push({ url: res.banner9 });
        }

        Toast.clear();
      });
    },

    // 获得焦点
    inputFocus(e) {
      this.scrollTop = "-" + (e.srcElement.getBoundingClientRect().top - 200);
      this.isShowStyle = true;
    },
    // 失去焦点
    inputBlur() {
      this.isShowStyle = false;
    },
    handleReturn() {
      history.back();
    },

    // 图片上传
    clickUpload(type) {
      this.isType = type;
    },
    // 删除图片
    deleteImg(isType) {
      if (isType == 1) {
        this.formData.img = "";
      } else if (isType == 2) {
        this.formData.banner = "";
      } else if (isType == 3) {
        this.formData.banner2 = "";
      } else if (isType == 4) {
        this.formData.banner3 = "";
      } else if (isType == 5) {
        this.formData.banner4 = "";
      } else if (isType == 6) {
        this.formData.banner5 = "";
      } else if (isType == 7) {
        this.formData.banner6 = "";
      } else if (isType == 8) {
        this.formData.banner7 = "";
      } else if (isType == 9) {
        this.formData.banner8 = "";
      } else if (isType == 10) {
        this.formData.banner9 = "";
      }
    },
    // 图片上传之前处理
    beforeRead(file) {
      const imgformat = /image\/(png|jpg|jpeg)$/;
      if (!imgformat.test(file.type)) {
        this.$toast.fail("请上传 jpg/png 格式图片");
        return false;
      }
      return true;
    },
    // 检测图片的宽高
    checkWidthAndHeight(file) {
      return new Promise((resolve, reject) => {
        let { isType } = this;
        let img = new Image();
        img.src = URL.createObjectURL(file);
        img.onload = function () {
          let width = img.width;
          var height = img.height;
          console.log("当前图片的宽高:" + width, height);
          if (isType == 1) {
            if (width == 500 && height == 500) {
              reject(true);
            } else {
              resolve(false);
            }
          }
        };
      });
    },
    // 图片上传后处理
    afterRead(e) {
      let { isType } = this;
      var formData = new FormData();
      formData.append("imgfile", e.file);
      const Toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
        duration: 0,
      });
      uploadImage(formData).then((res) => {
        if (res.result) {
          if (isType == 1) {
            this.formData.img = res.url;
          } else if (isType == 2) {
            this.formData.banner = res.url;
          } else if (isType == 3) {
            this.formData.banner2 = res.url;
          } else if (isType == 4) {
            this.formData.banner3 = res.url;
          } else if (isType == 5) {
            this.formData.banner4 = res.url;
          } else if (isType == 6) {
            this.formData.banner5 = res.url;
          } else if (isType == 7) {
            this.formData.banner6 = res.url;
          } else if (isType == 8) {
            this.formData.banner7 = res.url;
          } else if (isType == 9) {
            this.formData.banner8 = res.url;
          } else if (isType == 10) {
            this.formData.banner9 = res.url;
          }
          Toast.clear();
        } else {
          this.$toast.fail(res.message || "服务器报错，请稍后～");
          Toast.clear();
        }
      });
    },

    handleSubmit() {
      let { formData } = this;
      const Toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      // formData.img = this.imgSplit(formData.img);
      // formData.banner = this.imgSplit(formData.banner);
      // formData.banner2 = this.imgSplit(formData.banner2);
      // formData.banner3 = this.imgSplit(formData.banner3);
      // formData.banner4 = this.imgSplit(formData.banner4);
      // formData.banner5 = this.imgSplit(formData.banner5);
      if (formData.img == "") {
        this.$toast("请上传商品封面缩略图");
        return;
      }
      if (formData.banner == "") {
        this.$toast("请上传商品banner图");
        return;
      }
      editCommidity(formData).then((res) => {
        let data = res;
        if (data.result) {
          setTimeout(() => {
            Toast.clear();
            this.$toast.success(data.message);
          }, 500);
          // setTimeout(() => {
          //   history.back();
          // }, 1500);
        } else {
          Toast.clear();
          this.$toast.fail(data.message || "服务器报错，请稍后～");
        }
      });
    },
    // 图片路径的分割
    imgSplit(url) {
      if (url != "") {
        if (url.indexOf("upload")) {
          let splitArr = url.split("/upload/");
          return splitArr[splitArr.length - 1];
        } else if (url.indexOf("Upload")) {
          let splitArr = url.split("/Upload/");
          return splitArr[splitArr.length - 1];
        }
      } else {
        return "";
      }
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
  padding-bottom: 420px;
  .breadcrumb {
    padding-bottom: 60px;
  }
  .main_content {
    .tit {
      text-align: center;
      font-size: 32px;
      font-weight: bold;
      margin-bottom: 50px;
    }
    .block {
      margin-bottom: 80px;
      h1 {
        text-align: center;
        font-weight: 400;
        margin-bottom: 20px;
        font-size: 30px;
      }
      .img_box {
        margin: auto;
        margin-top: 40px;
        text-align: center;
      }
      p {
        font-size: 22px;
        text-align: center;
        &.red {
          color: #ff0012;
        }
      }
    }
  }
}
</style>